import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { valueRows, valueSummary, CHECKOUT_URL } from '../data/content';
export function ValueStack() {
  return <section id="comprar" className="w-full scroll-mt-20 bg-cream px-5 py-12 sm:py-20" data-id="element-299" data-mp="1q8uyyfvmh3uy">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-[600px] text-center" data-id="element-300" data-mp="1u9omv992einu">
        <span className="mb-5 inline-block rounded-full border border-gold/50 bg-card px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-plum" data-id="element-301" data-mp="2n0gavjfz8103">
          Todo incluido en un único acceso
        </span>
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-302" data-mp="30yn0kcaruuoo">
          Esto es todo lo que recibís hoy con Aura Viva 2026
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-plum/75 sm:text-base" data-id="element-303" data-mp="35r7q31mnalme">
          Una biblioteca digital de autocuidado y bienestar energético organizada para que puedas
          comenzar sin perderte entre archivos.
        </p>

        <div className="mt-6 rounded-2xl border border-aura/20 bg-card p-4 text-left sm:mt-8 sm:p-6" data-id="element-304" data-mp="235o9pa9tqxf7">
          <ul className="divide-y divide-dashed divide-aura/20" data-id="element-305" data-mp="1ye6aorrd36wv">
            {valueRows.map(row => <li key={row.label} className="py-3 first:pt-0 last:pb-0" data-id="element-306" data-mp="2c52ze7i633yn">
                <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1" data-id="element-307" data-mp="284j479h5maf5">
                  <span className={`text-[10px] font-bold uppercase tracking-wider ${row.featured ? 'text-gold' : 'text-plum/50'}`} data-id="element-308" data-mp="286lr3kn0fnfn">
                    {row.kind}
                  </span>
                  <span className="text-sm font-bold text-aura sm:text-[15px]" data-id="element-309" data-mp="rqj520q4uosy">{row.label}</span>
                </div>
                <p className="mt-1 text-[13px] leading-relaxed text-plum/70" data-id="element-310" data-mp="mt0ts3on7xhs">{row.description}</p>
              </li>)}
          </ul>

          <div className="my-5 h-px w-full bg-gold/40" data-id="element-311" data-mp="2rrh516t14ncc" />

          <ul className="grid grid-cols-2 gap-3 sm:grid-cols-5 sm:gap-2" data-id="element-312" data-mp="2ru3mby5q2h7r">
            {valueSummary.map(item => <li key={item.label} className="flex flex-col items-center rounded-xl bg-lavender/60 px-2 py-3 text-center" data-id="element-313" data-mp="30sp2jmnq1k5d">
                <span className="font-serif-display text-2xl font-bold leading-none text-gold" data-id="element-314" data-mp="35pxkbm4yjm63">
                  {item.value}
                </span>
                <span className="mt-1.5 text-[11px] font-medium leading-snug text-plum" data-id="element-315" data-mp="3fhl7hauheh1r">
                  {item.label}
                </span>
              </li>)}
          </ul>

          <p className="mt-5 text-center text-[13px] leading-relaxed text-plum/75 sm:text-sm" data-id="element-316" data-mp="3oj1gbe5neb3v">
            Todo organizado para que no tengas que seguir guardando rituales, consejos y prácticas
            aisladas sin saber por dónde comenzar.
          </p>

          <div className="mt-6 flex flex-col items-center rounded-xl border border-gold/40 bg-card py-7 text-center" data-id="element-317" data-mp="7e2h6mauohch">
            <span className="text-sm font-medium text-aura" data-id="element-318" data-mp="3tndbe5b6sbbn">Accedé hoy al sistema completo</span>
            <span className="mt-2 font-serif-display text-[56px] font-bold leading-none text-plum sm:text-7xl" data-id="element-319" data-mp="3plrw6db6jkya">
              USD 12
            </span>
            <p className="mt-3 px-4 text-xs font-medium text-plum/75 sm:text-sm" data-id="element-320" data-mp="q5bruywcxc5n">
              Pago único · Sin suscripción · Acceso de por vida
            </p>
            <div className="mx-4 mt-5 rounded-xl bg-lavender px-4 py-3" data-id="element-321" data-mp="ggbn0yv6bmjj">
              <p className="text-xs font-semibold leading-relaxed text-plum sm:text-sm" data-id="element-322" data-mp="geh2hlntdwfz">
                🌎 Podés adquirir Aura Viva 2026 desde cualquier país de Latinoamérica.
              </p>
              <p className="mt-1.5 text-xs leading-relaxed text-plum/75 sm:text-[13px]" data-id="element-323" data-mp="18yz5e6iscngx">
                La página convierte automáticamente el precio a tu moneda local antes de confirmar
                la compra.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 sm:mt-8" data-id="element-324" data-mp="tosogvbq32d7">
          <CTAButton label="QUIERO ACCEDER POR USD 12" href={CHECKOUT_URL} textClassName="text-[14px] sm:text-[17px]" data-id="element-325" data-mp="fnzt68dlk391" />
          <p className="mt-3 text-xs text-plum/70 sm:text-sm" data-id="element-326" data-mp="jre80vpsudkw">
            Acceso digital inmediato después de confirmar el pago.
          </p>
        </div>
      </motion.div>
    </section>;
}